import React from "react"
import styled from "styled-components"
import { Theme } from "@pga/pga-component-library"
import AlertTriangleIcon from "../../assets/icons/icon-alert-triangle.svg"
import { flags, useFeatureFlags } from "../../lib/feature-flags"

const Notice = styled.aside`
  width: 100%;
  padding: 12px 16px;
  margin-bottom: 16px;
  background: #fff8e6;
  border-radius: 8px;
  outline: 1px solid #c47f00;
  outline-offset: -1px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
`

const IconWrapper = styled.div`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
`

const Icon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const Title = styled.div`
  color: ${Theme.colors.primary};
  font-size: 12px;
  font-family: ${Theme.fonts.Montserrat};
  font-weight: 700;
  line-height: 1.4;
`

const Message = styled.div`
  color: ${Theme.colors.primary};
  font-size: 12px;
  font-family: ${Theme.fonts.Montserrat};
  font-weight: 500;
  line-height: 1.4;
`

/**
 * Persistent Progress Standing Notice for PGM Progress Surfaces while
 * Progress-Privileged or Reapply-Gated. Driven by acceptableProgressStanding.
 * Gated by account-terminated-notice for staged rollout / copy iteration.
 */
const ProgressStandingNotice = ({ standing }) => {
  const [isTerminatedNoticeEnabled] =
    useFeatureFlags([flags.FLAG_FEAT_TERMINATED_NOTICE]) ?? []

  if (!isTerminatedNoticeEnabled || !standing?.showProgressStandingNotice) {
    return null
  }

  return (
    <Notice role="status" aria-live="polite">
      <IconWrapper>
        <Icon src={AlertTriangleIcon} alt="" />
      </IconWrapper>
      <Content>
        <Title>Membership terminated for Acceptable Progress</Title>
        <Message>
          Finishing the current level does not clear you to purchase the next
          level. You must reapply and be cleared to continue before advancing.
        </Message>
      </Content>
    </Notice>
  )
}

export default ProgressStandingNotice
